import { Component, OnInit, AfterViewInit, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppHistoryLog, ApplicationDetail, ChangeType, DocumentDetail, InspectionInfoDetail } from '../../models/ApplicationDetail';
import { ApplicationService } from '../../shared/services/application.service';
import * as Constants from '../../models/Constants';
import { ProfessionalConfigFilter } from '../../models/ProfessionalType';
import { SettingsService } from '../../shared/services/settings.service';
import { FoodManufDoc, ProfessionalType } from '../../models/CommonModels';
import { AccountService } from '../../services/account.service';
import { UserDto } from '../../models/User';
import { PreviewModalService } from '../../shared/services/preview-modal.service';
import { SubDataVariables } from '../../../environments/app.variables';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertService } from '../../shared/services/alert.service';
import { CheckListValueModel } from '../../models/ApplicationModel';
import { DocumentRef } from '../../models/DocumentRef';
import { saveAs } from 'file-saver';
import { ModalService } from '../../shared/components/modal/modal.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-pre-inspection-detail',
  templateUrl: './pre-inspection-detail.component.html',
  styleUrls: ['./pre-inspection-detail.component.css']
})
export class PreInspectionDetailComponent implements OnInit, AfterViewInit {

  public constants: any = Constants;
  public applicationID: number;
  public application: ApplicationDetail;
  public pAndpi: string[][] = new Array();
  public detailReady: boolean; 
  public configuredProfessionalTypes: Array<ProfessionalType> = []; 
  public inspectionResults: Array<InspectionInfoDetail>;
  public historyLog: Array<AppHistoryLog> = [];
  public currentUser: UserDto;
  public applicationNumber: string;
  public modalTitle: string;
  public modalButtonLabel: string;
  public modalApplicationStatus: string;
  public modalMode: boolean;
  public inspectionEditFileName: string;
  public inspectionEditComment: string;
  public inspectionResultID: number = -1;
  public activeTab: string;
  public showFoodManufacturing = false;
  public showWarehousesTab = false;
  public showChecklistTab = false;
  public showManufacturing = false;
  public showInspectionResultTab = false;
  public showInspectionPreparationActions = false;
  public showInspectionActions = false;
  public showRequestFIRAction = false;
  public showSelfInspectionActions = false;
  public showReturnToInspectorActions = false;
  public showInspectionRejectedActions = false;
  public showRtrnToInspTeamLeaderActions = false;
  public showSubmitForFIRAction = false;
  public showInspectionFailedActions = false;
  public showSelfInspectionFailedActions = false;
  public showInspectionPassedActions = false;
  public showSelfInspectionPassedActions = false;
  public showSubmitForApproval: boolean;
  public responseLabel = '';
  public compareMode = false;
  public count: number;
  public checklistDiff: number;
  public showChecklistScreeningActions = false;
  public showQuarantineActionButton: boolean = false;
  public showUndoQuarantineActionButton: boolean = false;
  public showEnketoForm = false;
  public currentInspectionResult : InspectionInfoDetail = null;
  public showFileColumnsInspectionResult = false; 
  public showOdkColumnsInspectionResult = false;
  public documentRefs: Array<DocumentRef> = [];
  public _changeTypes: Array<ChangeType> = [];
  public showInspectionInfoRequestTab: boolean;
  public preInspectionDocRefs: DocumentRef[];
  public facilityLocLatitiude: number;
  public facilityLocLongitude: number;
  public modalRef: BsModalRef;
  public showRequestFIRAfterInspectionAction: boolean = false;
  public showSubmitForFIRAfterInspectionAction: boolean = false;
  public showFISubmittedAfterInspectionAction: boolean = false;

  constructor(private route: ActivatedRoute, private applicationService: ApplicationService, private settingsService: SettingsService,
    private accountService: AccountService, private previewService: PreviewModalService, private spinner: NgxSpinnerService,
    private alertService: AlertService, private modalService: BsModalService) { 
    this.currentUser = this.accountService.getUserData();
  }

  ngOnInit() {

  }

  ngAfterViewInit() {
    this.route.params.subscribe(params => {
      this.applicationID = params['id'];
      this.viewHistoryLog(this.applicationID);
      this.getApplication();
    });
  }

  activateTab(tab) {
    $('.nav-tabs a[href="#' + tab + '"]').tab('show');
  };

  private getApplication() {
    this.applicationService.getApplication(this.applicationID).subscribe(data => {
      this.application = new ApplicationDetail(data, null);
      this.fetchConfiguredProfessionalTypes();
      this.setApplicationNumber(this.applicationID, this.application);
      for(let i=0; i< this.application.specificProductObjects.length; i++){
        let tempData = [];
        tempData.push(this.application.specificProductObjects[i].name);

        for(let l=0; l< this.application.specificProductItemObjects.length; l++){
           if (this.application.specificProductItemObjects[l].specificProductID === this.application.specificProductObjects[i].id){
            let spItem = this.application.specificProductItemObjects[l].name;
            if(this.application.specificProductItemObjects[l].brandName){
              spItem = `${spItem} [${this.application.specificProductItemObjects[l].brandName}]`;
            }
            tempData.push(spItem);
           }
        }
        this.pAndpi.push(tempData);
      }


      this.showWarehousesTab = this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_ADD_WAREHOUSE ||
          this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_TEMP_ADD_WAREHOUSE ||
          (this.application.warehouses != null && this.application.warehouses.length > 0);
      this.showManufacturing = this.application.facility.facilityType === Constants.MANUFACTURER;
      this.showFoodManufacturing = this.showManufacturing && this.application.productType === Constants.PRODUCT_TYPE_FOOD;
      if (this.application.checkListItems.length) {
        this.showChecklistTab = true;
        this.application.checkListItems.forEach(function (checklist) {
          if (checklist.screenerResponseValue === null) {
            checklist.screenerResponseValue = new CheckListValueModel();
          }
        });
      }

      const plc = (this.application.facility.ownershipTypeCode === Constants.PLC);
      const focalPerson = (this.application.applicationTypeCode === Constants.FOCAL_PERSON);
      var foodManDoc: FoodManufDoc = null;
      if (this.application.facility.facilityType === Constants.MANUFACTURER && this.application.productType === Constants.PRODUCT_TYPE_FOOD) {
        foodManDoc = { mLevelID: this.application.mLevelID, mRLevelID: this.application.mrLevelID };
      }
      this.application.newApplicationChangeTypes.forEach(newApplicationChangeType =>{
        this._changeTypes.push(newApplicationChangeType.changeType);
      });

      this.applicationService.getDocumentRef(this.application.facility.facilityTypeID, this.application.productTypeID, plc, focalPerson, this.application.applicationCategory,
        this.application.applicationCategory.applicationCategoryCode === 'REN' ?this.application.facility.facilityCategoryID:null, foodManDoc,
        (this.application.applicationCategory.applicationCategoryCode === 'CHG' ||
        this.application.applicationCategory.applicationCategoryCode === 'CTC')? this._changeTypes.map(c => c.changeTypeRefID) : null,
        this.application.applicationCategory.applicationCategoryCode === 'REP' ? this.application.applicationInfo.replacementReasonID : null)
        .subscribe(documents => {
          Array.prototype.push.apply(this.documentRefs, documents);
          this.documentRefs = this.documentRefs.filter(d => d.name != "Payment Receipt for Evaluation");
          var index = this.application.documents.findIndex(d => d.referenceID == 39);//reference id for bank statement or investment license
          if (this.application.productType == Constants.PRODUCT_TYPE_FOOD && this.application.facility.facilityType == Constants.MANUFACTURER &&
             this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_NEW && index === -1) {
            // fetch doc ref for Investment License and Bank Statement to show the documents of applications before they are merged together
            this.applicationService.getDocRefById(22).subscribe(doc => this.documentRefs.push(doc));
            this.applicationService.getDocRefById(23).subscribe(doc => this.documentRefs.push(doc));
          }
      });

      if (this.application.applicationCategory && this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_RENEWAL) {
        this.responseLabel = 'Inspector Response';
      } else {
        this.responseLabel = 'Screener Response';
      }

      this.activeTab = 'applicantInfo';
      this.activateTab(this.activeTab);

      this.getInspectionResultDoc();
      this.getInspectionPrerequisiteInfo();

      this.setActionButtons();
    });
  }

  fetchConfiguredProfessionalTypes() {
    this.configuredProfessionalTypes = [];
    let professionalConfigFilter = new ProfessionalConfigFilter();
    if([Constants.APPLICATION_TYPE_CODE_TEMP_COC, Constants.APPLICATION_TYPE_CODE_TEMP_CHANGE, Constants.APPLICATION_TYPE_CODE_TEMP_ADD_WAREHOUSE,
      Constants.APPLICATION_TYPE_CODE_TEMP_RETURN_COC].indexOf(this.application.applicationCategory.applicationCategoryCode) > -1){
        professionalConfigFilter.applicationCategoryID = 7; // id for TCC
    } else {
        professionalConfigFilter.applicationCategoryID = 1; // id for new application
    }

    professionalConfigFilter.facilityTypeID = this.application.facility.facilityTypeID;
    professionalConfigFilter.productTypeID =  this.application.productTypeID;

    if(this.showFoodManufacturing){
      professionalConfigFilter.manufacturingRiskLevelID = this.application.mrLevelID;
      professionalConfigFilter.manufacturingLevelID = this.application.mLevelID;
    }

    this.settingsService.getConfiguredProfessionalTypes(professionalConfigFilter).subscribe( res => {
      this.configuredProfessionalTypes = res;
      this.detailReady = true;
    }, err => {

    }, () => {

    });
  }

  isProfessionalTypeVisible(professionalTypeCode){
    return this.configuredProfessionalTypes.findIndex(p => p.professionalTypeCode == professionalTypeCode) > -1;
  }

  getInspectionFilesName() {
    this.inspectionResults.map(result => {
      if(result.fileName){
        let fileName = result.fileName.replace(/^.*[\\\/]/, '');
        !fileName.length ? result.fileName = '-' : result.fileName = fileName;
      }else {
        result.fileName = '-';
      }

      result.inspectionIdentifier = result.inspectionIdentifier || '-';
      result.uploadedTime = result.uploadedTime ? this.getDateString(result.uploadedTime) : '-';
      result.odkFormUploadDate = result.odkFormUploadDate ? this.getDateString(result.odkFormUploadDate) : '-';
      return result;
    });
  }

  getInspectionResultDoc() {
    this.inspectionResults = this.application.inspectionInfos;
    this.inspectionResults.forEach(element => {
      if(element.fileId){
        this.showFileColumnsInspectionResult = true;
      }
      if(element.odkResponseUUID){
        this.showOdkColumnsInspectionResult = true;
      }
    });
    this.showInspectionResultTab = this.inspectionResults && this.inspectionResults.length && this.inspectionResults.length > 0;
    this.getInspectionFilesName();
  }

  getDateString(InputDate) {
    let date = new Date(InputDate);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric'});
  }

  getInspectionStatus(statusId) {
    if (this.historyLog) {
      const inspStatus = this.historyLog.find(function (x) {
        return x.newValue === statusId;
      });

      if (inspStatus && inspStatus.newCode === Constants.INSPECTION_FAILED_CODE) {
        return 'Fail';
      } else if (inspStatus && inspStatus.newCode === Constants.INSPECTED_CODE) {
        return 'Pass';
      }
    }

    return '';
  }

  viewHistoryLog(id) {
    this.applicationService.getApplicationHistory(id).subscribe(res => {
      this.historyLog = res;
    });
  }

  inspectionResultEditable(index: number) {
    if (index !== 0) {
      return false;
    }
    if (this.application.applicationStatusCode === Constants.INSPECTED_CODE ||
      this.application.applicationStatusCode === Constants.INSPECTION_FAILED_CODE ||
      this.application.applicationStatusCode === Constants.RETURN_TO_INSPECTOR_CODE) {
      return (this.accountService.isUserInspector() && this.isUserAssignedToApplication());
    }

    return false;
  }

  isUserAssignedToApplication(): boolean {
    return this.application.applicationUserAssignemnts.find(obj => obj.userID === this.currentUser.id && obj.primary) !== undefined;
  }

  appShouldBeQuarantined(app : ApplicationDetail){
    if([Constants.INSPECTOR_ASSIGNED_CODE, Constants.RETURN_TO_INSPECTOR_CODE].indexOf(app.applicationStatusCode) !== -1 && 
        app.applicationUserAssignemnts.length > 0){
      let assignment = app.applicationUserAssignemnts[0];
      let currentDate = new Date();
      let daysDifference = (currentDate.getTime() - assignment.createdDate.getTime()) / (1000 * 3600 * 24);
      if(daysDifference > 180){
        return true;
      }
    }
    return false;
  }
  
  isInspectionQRCodeDocAlreadyCreated(){
    let submittedInspectionOdkIds = this.application.inspectionInfos.map(i => i.inspectionIdentifier);
    let qrCodeDocs = this.application.documents.filter(d => d.referenceID == 64 && submittedInspectionOdkIds.indexOf(d.remark) === -1); // inspection QR code document
    return qrCodeDocs.length !== 0;
  }

  showInspectionQRCodeDocument(){
    const attachmentUrl = SubDataVariables.PREINSPECTION_QRCODE_URL + '/' + this.application.id;
    this.previewService.openModal(attachmentUrl, "Inspection", true);
  }

  // check if the inspection was already done with the old way instead of odk virtual forms
  // also odk is used for medicine, medical device, medicine and medical device importer and wholesaler
  isInspectionSubmittedWithDoc(){
    return (this.application.applicationStatusCode === Constants.RETURN_TO_INSPECTOR_CODE && 
      this.application.documents.filter(d => d.referenceID == 64).length == 0) || !(
        ([Constants.IMPORTER, Constants.WHOLESALER, Constants.MANUFACTURER].findIndex(n => n == this.application.facility.facilityType) !== -1 &&
        [Constants.PRODUCT_TYPE_MEDICINE, Constants.PRODUCT_TYPE_MED_DEVICES, Constants.PRODUCT_TYPE_MED_AND_MED_DEVICES, Constants.PRODUCT_TYPE_FOOD,
          Constants.PRODUCT_TYPE_SMALL_SCALE_MEDICINE,Constants.PRODUCT_TYPE_MEDICAL_GAS, Constants.PRODUCT_TYPE_TOBACCO].findIndex(n => n == this.application.productType) !== -1) || 
          ([Constants.IMPORTER, Constants.MANUFACTURER].findIndex(n => n ==this.application.facility.facilityType) !== -1 && 
            this.application.productType == Constants.PRODUCT_TYPE_COSMETICS) 
        );
  }

  showGenerateInspectionQRCodeDocButton(){
    return (this.showInspectionPreparationActions || this.showInspectionActions) && !this.isInspectionQRCodeDocAlreadyCreated();
  }

  generateInspectionQRCode(){
    this.spinner.show();
    this.applicationService.generatePreInspectionQRCode(this.application.id).subscribe(doc => {
      this.spinner.hide();
      if(doc){
        this.application.documents.push(new DocumentDetail(doc));
        this.alertService.success("Inspection QR Code document generated successfully!")
      }else {
        this.alertService.success("Couldn't generate the Inspection QR Code document, please try again!")
      }
    }, err => {
      this.spinner.hide();
      this.alertService.success("Couldn't generate the Inspection QR Code document, please try again!")
      console.log(err);
    });
  }

  setApplicationNumber(id, application) {
    this.applicationNumber = '0'.repeat(Math.max(5, id.toString().length) - id.toString().length) + id + application.applicationNumber; 
  }

  inspectionPreviewModal(inspectionResult: InspectionInfoDetail, filePreviewing: boolean){
    if(filePreviewing){
      // the old inspection result from uploaded doc
      let modalName = inspectionResult.fileName;
      let docID = inspectionResult.fileId;
      const attachmentUrl = SubDataVariables.ATTACHMENT_SINGLE_URL + '/' + docID;
      this.previewService.openModal(attachmentUrl, modalName, true);
    }else {
      // the new inspection result from odk virtual form
      this.currentInspectionResult = inspectionResult;
      this.showEnketoForm = true;
    }
  }

  showEditModal(fileName: string, comment: string, inspectionId: number) {
    this.modalTitle = 'Editing Inspection Result';
    if (this.application.applicationStatusCode === Constants.INSPECTED_CODE) {
      this.modalButtonLabel = Constants.PASS;
    } else {
      this.modalButtonLabel = Constants.PASS;
    }

    this.modalApplicationStatus = this.application.applicationStatusCode;
    this.modalMode = true;
    this.inspectionEditComment = comment;
    this.inspectionEditFileName = fileName;
    this.inspectionResultID = inspectionId;
    $('#applicationModal').modal('show');
  }

  setActionButtons(){
    let statusCode = this.application.applicationStatusCode;
    let categoryCode =  this.application.applicationCategory.applicationCategoryCode;
    let facilityCategory = this.application.facility.facilityCategory.name;

    if(this.accountService.isUserInspector() && this.isUserAssignedToApplication()) {
      if([Constants.INSPECTOR_ASSIGNED_CODE, Constants.FI_SUBMITTED, Constants.RETURN_TO_INSPECTOR_CODE].indexOf(statusCode) > -1){
        this.showRequestFIRAction = [Constants.INSPECTOR_ASSIGNED_CODE, Constants.FI_SUBMITTED].includes(statusCode);
        this.showRequestFIRAfterInspectionAction = [Constants.RETURN_TO_INSPECTOR_CODE, Constants.FI_SUBMITTED_AFTER_INSPECTION].includes(statusCode);
        this.showInspectionPreparationActions = [Constants.MANUFACTURER, Constants.EXPORTER].indexOf(this.application.facility.facilityType) == -1;
        this.showInspectionActions = statusCode == Constants.FI_SUBMITTED_AFTER_INSPECTION || [Constants.MANUFACTURER, Constants.EXPORTER].indexOf(this.application.facility.facilityType) !== -1;
        if(categoryCode === Constants.APPLICATION_TYPE_CODE_RENEWAL){
          this.showChecklistScreeningActions = true;
          if(this.application.facility.facilityCategory.name !== Constants.FACILITY_CAT_RED){
            this.showSelfInspectionActions = true;
            this.showInspectionPreparationActions = false;
            this.showInspectionActions = false;
          } 
        } 
      }

      if([Constants.INFO_FOR_INSPECTION_SUBMITTED, Constants.RETURN_TO_INSPECTOR_CODE].indexOf(statusCode) > -1){
        this.showInspectionActions = true;
      }
    }
    
    if(((this.accountService.isUserDirector() || this.accountService.isUserInspectionTeamLeader()) && this.appShouldBeQuarantined(this.application))){
      this.showQuarantineActionButton = true; 
    } else if (((this.accountService.isUserDirector() || this.accountService.isUserInspectionTeamLeader()) && this.application.applicationStatusCode == Constants.QUARANTINED)){
      this.showUndoQuarantineActionButton = true;
    }

    if (this.accountService.isUserInspectionTeamLeader()) {

      this.showInspectionPassedActions = statusCode == Constants.INSPECTED_CODE;
      this.showSelfInspectionPassedActions = statusCode == Constants.SELF_INSPECTION_PASSED_CODE;
      this.showInspectionFailedActions = statusCode == Constants.INSPECTION_FAILED_CODE;
      this.showSelfInspectionFailedActions = statusCode == Constants.SELF_INSPECTION_FAILED_CODE;
      this.showInspectionRejectedActions = statusCode === Constants.INSPECTION_REJECTED_CODE
      this.showRtrnToInspTeamLeaderActions = statusCode === Constants.RETURN_TO_INSPECTOR_TEAM_LEADER_CODE;
      this.showSubmitForFIRAction = statusCode === Constants.FIR_REQUESTED && !this.application.isLegacyData;
      this.showSubmitForFIRAfterInspectionAction = statusCode == Constants.FIR_REQUESTED_AFTER_INSPECTION && !this.application.isLegacyData;
      this.showFISubmittedAfterInspectionAction = statusCode === Constants.FI_SUBMITTED_AFTER_INSPECTION;
      if(statusCode === Constants.PRESCREENED_CODE && categoryCode === Constants.APPLICATION_TYPE_CODE_RENEWAL && 
        facilityCategory === Constants.FACILITY_CAT_GREEN){
        this.showSubmitForApproval = true;
        this.showChecklistScreeningActions = true;
      }
    }
  }

  showActionButton(){
    return this.showInspectionPreparationActions || this.showSelfInspectionActions || this.showRequestFIRAction || this.showInspectionPassedActions ||
      this.showInspectionFailedActions || this.showInspectionRejectedActions || this.showRtrnToInspTeamLeaderActions ||
      this.showSubmitForFIRAction || this.showChecklistScreeningActions || this.showSelfInspectionPassedActions || 
      this.showSelfInspectionFailedActions || this.showInspectionActions || this.showRequestFIRAfterInspectionAction || this.showSubmitForFIRAfterInspectionAction ||
      this.showFISubmittedAfterInspectionAction;
  }

  showModal(applicationStatus) {
    this.modalTitle = Constants.STATUS_CHANGE_MODAL_MAP[applicationStatus].title;
    this.modalButtonLabel = Constants.STATUS_CHANGE_MODAL_MAP[applicationStatus].buttonLabel;
    this.modalApplicationStatus = applicationStatus;
    $('#applicationModal').modal('show');
  }

  compareButtonPressed() {
    this.compareMode = true;
    this.count = 0;
    this.application.checkListItems.forEach(checklist => {
      if(checklist.screenerResponseValue.name === checklist.checkListValue.name){
            this.count = this.count + 1
            this.checklistDiff = Math.round(((this.count/this.application.checkListItems.length)*100));

      }
      if (checklist.screenerResponseValue.name === 'N/A') {
        checklist.compareResult = true;
      } else {
        checklist.compareResult = checklist.screenerResponseValue.name === checklist.checkListValue.name;
      }
    });
  }

  screenerResponseChanged(instance) {
    if (this.compareMode) {
      this.compareButtonPressed();
    }
  }

  disableButton() {
    for (let i = 0; i < this.application.checkListItems.length; i++) {
      if (!this.application.checkListItems[i].screenerResponseValue.name) {
        return true;
      }
    }
    return false;
  }

  completeClicked(complete) {
    const screenerResponse = {
      applicationId: this.application.id,
      checklistComplete: complete,
      checklistInstances: this.application.checkListItems
    };
    this.applicationService.checklistScreenedWithResponse(screenerResponse).subscribe(
      res => {
        if (res) {
          this.application.checklistComplete = complete;
          this.alertService.success('Successfully marked checklists as ' + (complete ? 'complete' : 'incomplete'));
        } else {
          this.alertService.error('Marking checklists as ' + (complete ? 'complete' : 'incomplete') + ' failed. Please try again later.');
        }
      },
      err => {
        this.alertService.error('Marking checklists as ' + (complete ? 'complete' : 'incomplete') + ' failed. Please try again later.');
      }
    );
  }

  onEnketoFormClosed(closed: boolean){
    if(closed){
      this.showEnketoForm = false;
    }
  }

  disableSubmitForApproval() {
    return this.application.applicationCategory.applicationCategoryCode === Constants.APPLICATION_TYPE_CODE_RENEWAL &&
      this.application.facility.facilityCategory.name === Constants.FACILITY_CAT_GREEN &&
      this.application.applicationStatusCode === Constants.PRESCREENED_CODE &&
      this.accountService.isUserInspectionTeamLeader() && this.application.checkListItems && this.application.checkListItems.length > 0 &&
      !this.application.checklistComplete;
  }

  getFileName(docRefID) {
    let doc;
    if(docRefID == Constants.CONSENT_DOC_REFERENCE_ID || docRefID == Constants.ADDITIONAL_DOCS_FOR_INSPECTION_REFERENCE_ID) {
      doc = this.getInspectionPreequisiteDoc(docRefID);
    } else {
      doc = this.getDocument(docRefID);
    }

    return this.getFileNameFromDoc(doc);
  }

  getFileNameFromDoc(doc){
    if (doc) {
      let fileName = doc.filePath.replace(/^.*[\\\/]/, '');
      if (!fileName.length) {
        fileName = '-';
      }
      return fileName;
    }

    return '-';
  }

  getUploadTime(docRefID) {
    let doc;

    if(docRefID == Constants.CONSENT_DOC_REFERENCE_ID || docRefID == Constants.ADDITIONAL_DOCS_FOR_INSPECTION_REFERENCE_ID) {
      doc = this.getInspectionPreequisiteDoc(docRefID);
    } else {
      doc = this.getDocument(docRefID);
    }

    return this.getUploadTimeFromDoc(doc);
  }

  getUploadTimeFromDoc(doc){
    if (doc) {
      return this.getDateString(doc.uploadTime ?? doc.modifiedDate);
    }

    return '-';
  }

  isFileAttached(docRefID) {
    const idx = this.application.documents.map(doc => {
      return doc.referenceID;
    }).findIndex((elt) => {

      return elt === docRefID;
    });
    if (idx !== -1) {
      return true;
    } else {
      return false;
    }

  }

  getDocument(docRefID) {
    const idx = this.application.documents.map(doc => {
      return doc.referenceID;
    }).findIndex((elt) => {
      return elt === docRefID;
    });

    if (idx !== -1) {
      return this.application.documents[idx];
    } else {
      return null;
    }
  }

  getInspectionPreequisiteDoc(docRefID){
    let usedPreReqDocIds = this.application.inspectionInfos.flatMap(i => i.inspectionInfoDocuments).map(d => d.documentID);
    let preReqDocs = this.application.documents.filter(d => d.documentReference.name == Constants.CONSENT_FORM_DOC || 
      d.documentReference.name == Constants.ADDITIONAL_DOCS_FOR_INSPECTION && !usedPreReqDocIds.includes(d.id));
    return preReqDocs.find(d => d.referenceID == docRefID);
  }

  previewModal(modalName: string, docRefID: number) {
    let doc;
   if(docRefID == Constants.CONSENT_DOC_REFERENCE_ID || docRefID == Constants.ADDITIONAL_DOCS_FOR_INSPECTION_REFERENCE_ID) {
      doc = this.getInspectionPreequisiteDoc(docRefID);
    } else {
      doc = this.getDocument(docRefID);
    }
    const attachmentUrl = SubDataVariables.ATTACHMENT_SINGLE_URL + '/' + doc.id;
    this.previewService.openModal(attachmentUrl, modalName, true);
  }

  downloadAttachment(name: string, docRefID: number) {
    let doc;
    if(docRefID == Constants.CONSENT_DOC_REFERENCE_ID || docRefID == Constants.ADDITIONAL_DOCS_FOR_INSPECTION_REFERENCE_ID) {
      doc = this.getInspectionPreequisiteDoc(docRefID);
    } else {
      doc = this.getDocument(docRefID);
    }
    this.applicationService.getAttachmentByID(doc.id).subscribe(data => {
      const blob = new Blob([data], {
        type: 'application/pdf'
      });
      saveAs(blob, name);
    });
  }

  gpsMarkerClicked(latitude: number, longitude: number){
    window.open(`https://www.google.com/maps?q=${latitude},${longitude}`, '_blank');
  }

  getInspectionPrerequisiteInfo(){
    this.showInspectionInfoRequestTab = this.accountService.isUserInspector() && 
        this.application.applicationStatusCode === Constants.INFO_FOR_INSPECTION_SUBMITTED;
    if(this.showInspectionInfoRequestTab){
      this.activeTab = 'inspectionInfoRequest';
      this.activateTab(this.activeTab);
      this.applicationService.getPreInspectionDocRefs().subscribe(documentRefsResp => {
        this.preInspectionDocRefs = documentRefsResp;
        var consentFormDoc = this.application.documents.filter(d => d.documentReference.name === Constants.CONSENT_FORM_DOC);
        if(consentFormDoc){
          let loc = consentFormDoc[0].remark;
          if(loc && loc.split('_').length == 2){
            this.facilityLocLatitiude = Number(loc.split('_')[0]);
            this.facilityLocLongitude = Number(loc.split('_')[1]);
          }
        }
      });
    }
  }

  previewInspectionPrerequisiteFile(modalName, docId) {
    const attachmentUrl = SubDataVariables.ATTACHMENT_SINGLE_URL + '/' + docId;
    this.previewService.openModal(attachmentUrl, modalName, true);
  }

  showInspDocModal(inspectionResultId: number, template: TemplateRef < any > ) {
    this.currentInspectionResult = this.inspectionResults.filter(r => r.id == inspectionResultId)[0];
    this.modalTitle = 'Inspection Prerequisite Documents';
    this.modalRef = this.modalService.show(template, {backdrop: 'static', keyboard: false});
  }
}
